/**
 * Extended Error class that includes additional context for debugging
 */
export class EnrichedError extends Error {
  constructor(
    message: string,
    public readonly originalError: unknown,
    public readonly context: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = 'EnrichedError';

    // Preserve stack trace from original error if available
    if (originalError instanceof Error && originalError.stack) {
      this.stack = `${this.stack}\n\nCaused by:\n${originalError.stack}`;
    }
  }
}

/**
 * Type guard to check if an error is an EnrichedError
 */
export function isEnrichedError(error: unknown): error is EnrichedError {
  return error instanceof EnrichedError;
}
